import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from '@node_modules/rxjs/internal/BehaviorSubject';
import {MatDialog} from '@node_modules/@angular/material';
import {ProgramViewComponent} from '@components/program-view/program-view.component';
import {Program} from '@models/program';
import {User} from '@models/user';
import {UpdateAuthUser} from '@store/auth/actions';
import {SubscriptionService} from '@services/subscription/subscription.service';
import * as AuthReducer from '@store/auth/reducers';
import {Store} from '@node_modules/@ngrx/store';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {ProgramService} from '@services/program/program.service';
import {PaymentService} from '@services/payment/payment.service';
import * as ProgramReducer from '@store/program/reducers';
import {SetPrograms} from '@store/program/actions';

@Component({
  selector: 'app-students-programs-listing',
  templateUrl: './students-programs-listing.component.html',
  styleUrls: ['./students-programs-listing.component.scss']
})
export class StudentsProgramsListingComponent implements OnInit {
  @Input() searchResultsSubject:  BehaviorSubject<Program[]>;
  @Input() usersPrograms:  BehaviorSubject<any>;
  @Input() usersProgramsWithSubscriptions:  BehaviorSubject<any>;
  @Input() usersProgramActive:  BehaviorSubject<any>;
  @Input() usersStopedSubscriptions:  BehaviorSubject<any>;
  @Input() onAddedToTheProgram:  BehaviorSubject<any>;
  @Input() mode = 'student';
  @Input() useProgramDetailShell = false;
  @Input() userSubject:  BehaviorSubject<User>;
  @Input() user:  User;
  @Output() programDetailSelected = new EventEmitter<Program>();
  items: Program[];
  programs: Program[];
  showMyPrograms = true;
  usersProgramId = [];
  usersProgramActiveArray = [];
  usersStopedSubscriptionsArray = [];
  usersStopedSubscriptionsProgramsIdArray = [];
  usersProgramsWithSubscriptionsArray = [];
  viewDialog;
  confirmDialog;
  confirmStopDialog;

  constructor(
    public dialog: MatDialog,
    private programService: ProgramService,
    private paymentService: PaymentService,
    private authStore: Store<AuthReducer.AuthState>,
    private programStore: Store<ProgramReducer.ProgramState>,
    private subscriptionService: SubscriptionService,
  ) { }

  ngOnInit() {
    this.programStore.subscribe(
      (val) => {
        if (val && val.program) {
          const programs = val.program;
          this.programs = programs.programs;
        }
      }
    );
    this.usersStopedSubscriptions.subscribe(
      resp => {
        // console.log(resp);
        this.usersStopedSubscriptionsArray = resp;
        this.usersStopedSubscriptionsProgramsIdArray = [];
        resp.map(item => {
          this.usersStopedSubscriptionsProgramsIdArray.push(item.program_id);
        });
      }
    );
    this.searchResultsSubject.subscribe(
      resp => {
        // console.log(resp);
        this.items = resp;
      }
    );
    this.usersProgramActive.subscribe(
      resp => {
        // console.log(resp);
        this.usersProgramActiveArray = resp;
      }
    );
    this.usersProgramsWithSubscriptions.subscribe(
      resp => {
        // console.log(resp);
        this.usersProgramsWithSubscriptionsArray = resp;
      }
    );
    this.usersPrograms.subscribe(
      resp => {
        // console.log(resp);
        this.usersProgramId = resp;
      }
    );
    if (this.userSubject) {
      this.userSubject.subscribe(resp => {
        if (resp) {
          this.user = resp;
        }
      });
    }

    this.items = this.items.filter(item => {
      return this.usersProgramId.includes(item.id);
    })
  }
  isUsersProgram(program_id) {
    return this.usersProgramId.includes(program_id) || this.checkStopped(program_id);
  }
  openViewModal(event, program) {
    if (!event.target.closest('.menu-program-item')) {
      if (this.useProgramDetailShell) {
        this.programDetailSelected.emit(program);
        return;
      }

      // console.log(program);
      ProgramViewComponent.program = program;
      ProgramViewComponent.user = this.user;
      this.viewDialog = this.dialog.open(ProgramViewComponent);
      ProgramViewComponent.dialogRef = this.viewDialog;
      // this.viewDialog.afterOpen().subscribe(result => this.programSubject.next(program));
    }
  }
  backToPrograms() {}
  getProgramVisibilityLabel(program) {
    return program && program.private ? 'Private' : 'Public';
  }
  isRecurringProgram(program) {
    if (!program) {
      return false;
    }

    const repeat = program.repeat ? String(program.repeat).toLowerCase() : '';
    if (repeat === 'none' || repeat === 'false' || repeat === 'fixed') {
      return false;
    }
    if (repeat) {
      return true;
    }

    let recurring = false;
    this.getProgramSchedules(program).map(schedule => {
      const repeatTime = schedule && schedule.repeat_time ? String(schedule.repeat_time).toLowerCase() : '';
      if (repeatTime && repeatTime !== 'none' && repeatTime !== 'false' && repeatTime !== 'fixed') {
        recurring = true;
      }
    });

    return recurring;
  }
  getScheduleSummary(program) {
    const days = this.getScheduleDays(program);

    if (days.length === 0) {
      return program && program.address ? program.address : '';
    }

    return days.join(' · ');
  }
  getScheduleDays(program) {
    const days = [];

    this.getProgramSchedules(program).map(schedule => {
      this.getScheduleDayLabels(schedule).map(day => {
        if (days.indexOf(day) === -1) {
          days.push(day);
        }
      });
    });

    days.sort((a, b) => this.getDaySortIndex(a) - this.getDaySortIndex(b));
    return days;
  }
  private getProgramSchedules(program) {
    const schedules = [];

    if (!program) {
      return schedules;
    }

    if (program.schedule && program.schedule.length) {
      schedules.push(...program.schedule);
    }

    if (program.classes && program.classes.length) {
      program.classes.map(classItem => {
        if (classItem.schedule && classItem.schedule.length) {
          schedules.push(...classItem.schedule);
        }
      });
    }

    return schedules;
  }
  private getScheduleDayLabels(schedule) {
    const repeatTime = schedule && schedule.repeat_time ? String(schedule.repeat_time).toLowerCase() : '';
    const rawDay = schedule ? String(schedule.fullDayName || schedule.dayName || '').toLowerCase() : '';

    if (repeatTime === 'day') {
      return ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    }
    if (rawDay.indexOf('mon') === 0) {
      return ['Mon'];
    }
    if (rawDay.indexOf('tue') === 0) {
      return ['Tue'];
    }
    if (rawDay.indexOf('wed') === 0) {
      return ['Wed'];
    }
    if (rawDay.indexOf('thu') === 0) {
      return ['Thu'];
    }
    if (rawDay.indexOf('fri') === 0) {
      return ['Fri'];
    }
    if (rawDay.indexOf('sat') === 0) {
      return ['Sat'];
    }
    if (rawDay.indexOf('sun') === 0) {
      return ['Sun'];
    }

    return [];
  }
  private getDaySortIndex(day) {
    switch (day) {
      case 'Mon':
        return 1;
      case 'Tue':
        return 2;
      case 'Wed':
        return 3;
      case 'Thu':
        return 4;
      case 'Fri':
        return 5;
      case 'Sat':
        return 6;
      case 'Sun':
        return 7;
      default:
        return 8;
    }
  }
  // openConfirmDialog(action: string, subscription: Subscription, active = 1) {
  //   ConfirmModalComponent.insertedObject = this;
  //   ConfirmModalComponent.source = action;
  //   let body = {user_id: this.user.id,
  //     subscription_id: subscription.id,
  //     deleteAction: false,
  //     limited_class: subscription.limited,
  //     program_id: ProgramViewComponent.program.id,
  //     active: active,
  //   };
  //   if (action === 'unsubscribe') {
  //     body.deleteAction = true;
  //   }
  //   ConfirmModalComponent.methodDelete = 'subscriptionAction';
  //   ConfirmModalComponent.methodDeleteParam = body;
  //   this.confirmDialog = this.dialog.open(ConfirmModalComponent);
  //   ConfirmModalComponent.modalRef = this.confirmDialog;
  // }
  // subscriptionAction(body) {
  //   this.subscriptionService.toggleUserSubscription(body, body.deleteAction, body.limited_class)
  //     .subscribe(
  //       (resp: { data: User }) => {
  //         this.authStore.dispatch(new UpdateAuthUser(resp.data));
  //       }
  //     );
  // }

  addUserToProgram(program) {
    this.programService.addUser({
      user_id: this.user.id,
      program_id: program.id,
    }).subscribe(
      (resp: {data: Program|User}) => {
        if (this.mode === 'student') {
          this.user.programs_id.push(program.id);
          this.authStore.dispatch(new UpdateAuthUser({programs_id: this.user.programs_id}));
          this.programs.push(resp.data as Program);
          this.programStore.dispatch(new SetPrograms(this.programs));
        }
        if (this.mode === 'admin' && this.onAddedToTheProgram) {
          this.onAddedToTheProgram.next(this.user);
        }
      }
    );
  }
  checkStopped(program_id, subscription_id = null) {
    let found = false;
    this.usersStopedSubscriptionsArray.map( item => {
      if (item.program_id === program_id) {
        if (subscription_id || subscription_id === item.subscription_id)
        found = true;
      }
    });
    return found;
  }
  openConfirmDialog(program_id: number) {
    if (this.usersProgramActiveArray.includes(program_id) || this.usersStopedSubscriptionsProgramsIdArray.includes(program_id)) {
      ConfirmModalComponent.textModal = 'You can\'t delete program with ' + (this.usersStopedSubscriptionsProgramsIdArray.includes(program_id) ? 'stopped' : 'active') + ' subscription.';
      ConfirmModalComponent.source = 'info';
      ConfirmModalComponent.withButtons = false;
    } else {
      ConfirmModalComponent.withButtons = true;
      ConfirmModalComponent.source = 'deleteProgram';
      ConfirmModalComponent.textModal = 'Do you want to delete program?';
      ConfirmModalComponent.methodDelete =  'deleteProgram';
      ConfirmModalComponent.methodDeleteParam = {
        program_id: program_id,
        user_id: this.user.id,
      };
    }
    ConfirmModalComponent.insertedObject = this;
    // console.log(program_id);
    this.confirmStopDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmStopDialog;
  }
  deleteProgram(body) {
    this.programService.deleteUser(body).subscribe(
      (resp: {data: User}) => {
        // console.log(resp);
        this.authStore.dispatch(new UpdateAuthUser(resp.data));
        this.items = this.items.filter( item => resp.data.programs_id.includes(item.id));
        this.programStore.dispatch(new SetPrograms(this.items));
      }
    );
  }
}
